import { render, staticRenderFns } from "./VideoJS.vue?vue&type=template&id=428d56cd"
import script from "./VideoJS.vue?vue&type=script&lang=js"
export * from "./VideoJS.vue?vue&type=script&lang=js"
import style0 from "./VideoJS.vue?vue&type=style&index=0&id=428d56cd&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/lgweek/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('428d56cd')) {
      api.createRecord('428d56cd', component.options)
    } else {
      api.reload('428d56cd', component.options)
    }
    module.hot.accept("./VideoJS.vue?vue&type=template&id=428d56cd", function () {
      api.rerender('428d56cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/VideoJS.vue"
export default component.exports